// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"LongLasting_TheComp__tuiqr","moduleDesignComponent":"LongLasting_moduleDesignComponent__uildL"};